// 确认订单完成
import { AxiosServer } from '../../../utils';

export default function editGuaranteeStatus(param) {
    let axios = AxiosServer();
    return axios.post("client/editGuaranteeStatus", {
        param
    }).then(result => {
        if (result.data.status === true) {
            return result.data.msg;
        } else {
            return Promise.reject(result.data.msg);
        }
    });
}